export default [
  {
    path: "/casePendingList",
    component: () =>
      import(/* webpackChunkName: "casePending" */ "@/views/casesPending/list"),
    name: "casePendingList",
    meta: {
      isTab: true,
      keepAlive: false,
      links: ["待受理"],
      permissionsPath: "/casePendingList"
    }
  },
  {
    path: "/caseAccept",
    component: () =>
      import(
        /* webpackChunkName: "casePending" */ "@/views/casesPending/accept"
      ),
    name: "caseAccept",
    meta: {
      isTab: true,
      keepAlive: false,
      links: ["案件受理"],
      permissionsPath: "/casePendingList"
    }
  }
];
